module.exports = __webpack_public_path__ + "img/device_1004_1_select.b9ace144.svg";